import styled from "styled-components";
import { divisionLogos } from "../../../content-options/division-logos";
import {formatLiveLinkUrl} from '../../../utils/formatString';
import placeholderImage from "../../../images/common/vgc-logo.png"


const ClubInfo = ({ teamName, managerName, LiveLink, clubImage, league }) => {
  const { displayName, url } = formatLiveLinkUrl(LiveLink);

  return (
    <ActualWrapper>
      <Wrapper>
        <Container>
          <InfoContainer>
            <InfoBox className="gradient-gray-light">{teamName}</InfoBox>
            <InfoBox className="gradient-gray-light">{managerName}</InfoBox>
            <InfoBox className="gradient-gray-light">
              {url ? 
                <a href={url} target="_blank" rel="noopener noreferrer" className="text-decoration-none text-reset">
                  {displayName}
                </a> 
                : displayName}
            </InfoBox>
          </InfoContainer>
          <ImageContainer className="gradient-gray">
            <Img src={clubImage || placeholderImage}></Img>
          </ImageContainer>
        </Container>
      </Wrapper>
      <Wrapper>
        <Container>
          <ImageContainer className="gradient-gray">
            {league && league.division ? (
              <Img src={divisionLogos[league.division]}></Img>
            ) : null}
          </ImageContainer>
          <InfoContainer>
            {league ? (
              <>
                <InfoBox className="gradient-gray-light">
                  {league.leagueName} league
                </InfoBox>
                <InfoBox className="gradient-gray-light">
                  {league.continent}
                </InfoBox>
                <InfoBox className="gradient-gray-light">
                  {league.console}
                </InfoBox>
              </>
            ) : null}
          </InfoContainer>
        </Container>
      </Wrapper>
    </ActualWrapper>
  );
};
export default ClubInfo;
const ActualWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 575px) {
    padding: 0 1rem;
  }
  @media (min-width: 991px) {
    flex-direction: row;
    gap: 1rem;
    width: 100%;
  }
`;
const Wrapper = styled.div`
  margin-bottom: 1rem;
  width: 100%;
`;
const Container = styled.div`
  background: linear-gradient(120deg, #000000ff 60%, #040a2cff 100%);
  padding: 0.5rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  gap: 1rem;
  border-radius: 8px;
  border: 1px solid #5fa8e6;
  box-shadow: 0 0 5px 1px #00eaff;
  box-sizing: border-box;
`;

const InfoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.5rem;
  height: 100%;
  width: 100%;
  @media (min-width: 768px) {
    width: 300px;
  }
  @media (min-width: 991px) {
    width: 100%;
  }
  border-radius: 8px;
  box-sizing: border-box;
`;
const ImageContainer = styled.div`
  height: 100%;
  padding: 0.5rem;
  border-radius: 8px;
  background: linear-gradient(120deg, #000000ff 60%, #040a2cff 100%);
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 5px 1px #00eaff;
  display: flex;
  align-items: center;
  
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
`;
const Img = styled.img`
  height: 100px;
  @media (max-width: 400px) {
    height: 80px;
  }
  @media (max-width: 350px) {
    height: 70px;
  }
  border-radius: 8px;
`;
const InfoBox = styled.div`
  width: 100%;
  max-width: 300px;
  padding: 0.5rem;
  text-align: center;
  border-radius: 8px;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  border: 1px solid #5fa8e6;
  box-shadow: 0 0 4px 1px #00eaff;
  color: #fff;
  box-sizing: border-box;
`;
